import { useCallback, useRef } from 'react';
import { useIntl } from 'react-intl';

import { IBudgetServiceItem } from '../../../../../models/budgetV2';
import { fetchBudgetServiceItemsV2 } from '../../../../../api/fetchBudgetV2';
import BudgetSelectCustom from '../../BudgetSelectCustom';

interface IBudgetItemSelectProps {
  value: string;
  onChange: (option: IBudgetServiceItem | undefined) => void;
  disabled?: boolean;
  isRemoved?: boolean;
  autoFocus?: boolean;
}

export const BudgetItemSelect = (props: IBudgetItemSelectProps) => {
  const intl = useIntl();

  const allDataRef = useRef<IBudgetServiceItem[]>([]);
  const loadItemData = useCallback(
    async (
      searchTerm: string,
      pageSize: number,
      page: number,
    ): Promise<IBudgetServiceItem[]> => {
      try {
        const items = await fetchBudgetServiceItemsV2({ searchTerm, limit: pageSize, page });
        if (page === 1) {
          allDataRef.current = items;
        }
        return items;
      } catch (error) {
        if (page === 1 && allDataRef.current.length > 0) {
          return allDataRef.current;
        }
        return [];
      }
    },
    [],
  );

  return (
    <BudgetSelectCustom
      value={props.value ? [props.value] : []}
      onChange={props.onChange}
      loadData={loadItemData}
      getOptionLabel={(option) => option.item || ''}
      loadOnFocus
      disabled={props.disabled}
      isRemoved={props.isRemoved}
      autoFocus={props.autoFocus}
      initialLimit={10}
      placeholder={intl.formatMessage({ id: 'intl-msg:budgets.searchByItem' })}
      inputBorderColor="#14b8a6"
      inputBackgroundColor="#ffffff"
      dropdownBackgroundColor="#ffffff"
      highlightedOptionColor="#3b82f6"
      selectedOptionColor="#e5e7eb"
    />
  );
};